import { Menu } from 'components'
import { useCurrentUser } from 'components/providers'
import { upperCase } from 'lodash-es'
import { useEntevatePermission } from 'utils'
import { entevatePermissions } from './EntevatePermissionToggle'

export default function DevelopmentBarAction() {
  const [entevatePermission, setEntevatePermission] = useEntevatePermission()
  const user = useCurrentUser()

  if (!user?.isAdmin) return null

  return (
    <Menu
      size="sm"
      color="white"
      colorMode="light"
      variant="ghost"
      options={entevatePermissions.map(permission => ({
        value: permission,
        label: upperCase(permission),
      }))}
      value={entevatePermission}
      onChange={setEntevatePermission}
    />
  )
}
